/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { useDispatch, useSelector } from "react-redux"; // Hook to dispatch Redux actions and access state from the Redux store
import { useTranslation } from "react-i18next"; // Hook for handling internationalization and translations
import { useEffect, useState } from "react"; // React hooks for managing component lifecycle and state
import { GetContractorById } from "../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi"; // Redux action to fetch employee-contractor data by ID

// Main component for managing contractor access rights
const ContractorAccessRightsApp = () => {
    const { t } = useTranslation(); // Destructure the translation function for use in the component
    const dispatch = useDispatch(); // Get the dispatch function to trigger Redux actions
    const userId = useSelector((state) => state.authenticatioauthennSlice.user.data.id); // Get the current user ID from the Redux store
    const contractorIdU = useSelector((state) => state.ContractorSlice.getContractorsByUserId.id); // Get the contractor ID linked to the user

    // Local state to store the list of work shifts and customized access permissions
    const [workShiftsList, setWorkShiftsList] = useState([]);
    const [customizedList, setCustomizedList] = useState([]);

    // Get the contractorId from the session storage
    const contractorId = sessionStorage.getItem('contractorId');

    // useEffect hook to fetch data when the component mounts or when contractorIdU changes
    useEffect(() => {
        if (userId) {
            dispatch(GetContractorById(contractorId)).then(
                ({
                     payload: {
                         data: { data, success },
                     },
                 }) => {
                    if (success === true) {
                        // If custom permissions exist, map them to a new structure and update the state
                        if (data?.customs?.length > 0) {
                            const responseCustoms = data?.customs;
                            const customsList = responseCustoms.map((custom) => ({
                                ...custom,
                                added: true,
                            }));

                            setCustomizedList(customsList);
                        }

                        // If work shifts exist, map them to a new structure and update the state
                        if (data?.workShifts?.length > 0) {
                            const responseShifts = data?.workShifts;
                            const shiftsList = responseShifts.map((shift) => ({
                                ...shift,
                                added: true,
                            }));

                            setWorkShiftsList(shiftsList);
                        }
                    }
                },
            );
        }
    }, [contractorIdU]); // Re-run this effect whenever contractorIdU changes

    // Return necessary values and state setters to be used by components consuming this logic
    return {
        t,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList
    };
}

// Export the component for use in other parts of the application
export default ContractorAccessRightsApp;
